import React from 'react';
import { Button } from './Button';

export type SortDirection = 'asc' | 'desc';

export interface SortableThProps {
  label: string;
  sortKey: string;
  activeSortKey: string;
  sortDirection: SortDirection;
  onSort: (key: string) => void;
  className?: string;
  /** Font-size override for the sort trigger, to match the caller's ambient header text size (default matches Button's own text-xs). */
  textClassName?: string;
}

/**
 * Clickable <th> for hand-rolled admin tables (no shared <Table> primitive exists yet).
 * Renders the sort trigger via <Button variant="text"> rather than a raw <button> so it
 * doesn't trip the design-audit `raw_buttons` ratchet.
 */
export const SortableTh: React.FC<SortableThProps> = ({
  label,
  sortKey,
  activeSortKey,
  sortDirection,
  onSort,
  className = '',
  textClassName = '',
}) => {
  const isActive = activeSortKey === sortKey;

  return (
    <th
      scope="col"
      aria-sort={isActive ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={className}
    >
      <Button
        type="button"
        variant="text"
        size="sm"
        onClick={() => onSort(sortKey)}
        className={`!h-auto !min-h-0 !px-0 !py-0 gap-1 font-semibold text-inherit hover:text-text-primary ${textClassName}`}
      >
        {label}
        <span aria-hidden="true" className="inline-block w-3 text-[0.65rem] leading-none">
          {isActive ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
        </span>
      </Button>
    </th>
  );
};
